import React from 'react';
import ReactModal from 'react-modal';
import './PayrollDetailModal.css';

const HOURLY_RATE = 21;

const DAY_ABBREV = {
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
  Sunday: 'Sun',
};

function formatDays(daysOfWeek) {
  if (!daysOfWeek || daysOfWeek.length === 0) return null;
  return daysOfWeek.map(d => DAY_ABBREV[d] || d).join('/');
}

function formatTime(timeStr) {
  if (!timeStr) return null;
  const [hours, minutes] = timeStr.split(':');
  const h = parseInt(hours, 10);
  const suffix = h >= 12 ? 'pm' : 'am';
  const hour12 = h % 12 || 12;
  return `${hour12}:${minutes}${suffix}`;
}

function formatSessionDates(dates) {
  if (!dates || dates.length === 0) return null;
  // Sort dates and format as M/D
  const sorted = [...dates].sort();
  return sorted.map(d => {
    const [, month, day] = d.split('-');
    return `${parseInt(month, 10)}/${parseInt(day, 10)}`;
  }).join(', ');
}

function formatCurrency(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}

function PayrollDetailModal({ coachName, detailedResults, onClose }) {
  const coachPrograms = detailedResults.filter(r => r.coachName === coachName);

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      contentLabel="Payroll Details"
      ariaHideApp={false}
      className="payroll-detail-modal-content"
      overlayClassName="modal-overlay"
    >
      <div className="payroll-detail-modal">
        <button className="close-button" onClick={onClose}>&times;</button>
        <h2>{coachName} - Program Breakdown</h2>

        {coachPrograms.length === 0 ? (
          <p className="payroll-detail-empty">No program details found.</p>
        ) : (
          <table className="payroll-detail-table">
            <thead>
              <tr>
                <th>Program</th>
                <th>Setup Hrs</th>
                <th>Program Hrs</th>
                <th>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {coachPrograms.map((program, idx) => {
                const totalHours = (program.setupHours || 0) + (program.programHours || 0);
                const subtotal = totalHours * HOURLY_RATE;
                const detailParts = [
                  program.org?.toUpperCase(),
                  formatDays(program.daysOfWeek),
                  formatTime(program.startTime),
                ].filter(Boolean);
                return (
                  <tr key={idx}>
                    <td>
                      <div className="program-name">{program.programTitle || program.programId}</div>
                      {detailParts.length > 0 && (
                        <div className="program-details">{detailParts.join(' · ')}</div>
                      )}
                      {program.sessionDates?.length > 0 && (
                        <div className="program-dates">{formatSessionDates(program.sessionDates)}</div>
                      )}
                    </td>
                    <td>{(program.setupHours || 0).toFixed(2)}</td>
                    <td>{(program.programHours || 0).toFixed(2)}</td>
                    <td>{formatCurrency(subtotal)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}

        <div className="payroll-detail-actions">
          <button className="payroll-detail-close-btn" onClick={onClose}>Close</button>
        </div>
      </div>
    </ReactModal>
  );
}

export default PayrollDetailModal;
